export default __webpack_public_path__ + "static/media/scalebloc.8db34c47.png";